<template>
  <div class="page">
    <div class="container">
      <router-link class="page-back" to>
        <i class="mintui mintui-back back-btn" @click="onBack"></i>
      </router-link>
      <h1>训练总览</h1>
      <div class="line"></div>
      <Table
        :columns="columns"
        :data="list"
        border
        disabled-hover
        :loading="loading"
        :span-method="handleSpan"
      ></Table>
    </div>
  </div>
</template>
<script>
export default {
  name: "TotalSummary",
  data() {
    return {
      loading: false,
      columns: [
        {
          title: "项目类别",
          key: "subject",
          align: "center",
          minWidth: 80
        },
        {
          title: "项目名称",
          key: "course_name",
          align: "center",
          minWidth: 80
        },
        {
          title: "总训练次数",
          key: "train_count",
          align: "center",
          minWidth: 45
        },
        {
          title: "0扣分完成次数",
          key: "perfect_count",
          align: "center",
          minWidth: 45
        },
        {
          title: "累计出错次数",
          align: "center",
          minWidth: 45,
          render: (h, params) => {
            let course_name = params.row.course_name;
            let error_count = 0;
            let error_map = params.row.error_map;
            for (let key in error_map) {
              error_count += error_map[key];
            }
            return h(
              "div",
              {
                style: {
                  color: "#0000ff",
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.onDetail({ error_map, course_name });
                  }
                }
              },
              error_count
            );
          }
        }
      ],
      list: [],
      subjectNames: {
        2: "科目二",
        3: "科目三",
        11: "防御性课程及应急处置"
      }
    };
  },
  created() {
    let userId = this.$route.params.data;
    if (!Number.isFinite(userId)) return;
    this.loading = true;
    this.$post("/serviceapi/fetchTrainRecords", { userId }, data => {
      this.updateView(data);
    });
  },
  methods: {
    updateView(data) {
      let sortedData = this.sort(data);
      let listObj = this.integrate(sortedData);
      let list = this.transformList(listObj);
      this.list = list;

      this.loading = false;
    },
    sort(details) {
      return details.sort((a, b) => a.subject - b.subject);
    },
    integrate(data) {
      let listObj = {};
      for (let i in data) {
        let item = data[i];
        if (!item.course_name || !item.part_name) {
          continue;
        }
        let title = item.course_name;
        if (item.course_name === "防御性课程及应急处置") {
          title = item.part_name;
        }
        if (!listObj[title]) {
          listObj[title] = {};
          listObj[title].subject = this.subjectNames[item.subject];
          listObj[title].train_count = 0;
          listObj[title].perfect_count = 0;
          listObj[title].error_map = {};
        }
        listObj[title].train_count += item.train_count;
        listObj[title].perfect_count += item.perfect_count;
        for (let key in item.error_map) {
          let value = item.error_map[key];
          if (!listObj[title].error_map[key]) {
            listObj[title].error_map[key] = 0;
          }
          listObj[title].error_map[key] += value;
        }
      }
      return listObj;
    },
    transformList(listObj) {
      let list = [];
      for (let key in listObj) {
        let value = listObj[key];
        let obj = {};
        obj.course_name = key;
        obj.subject = value.subject;
        obj.train_count = value.train_count;
        obj.perfect_count = value.perfect_count;
        obj.error_map = value.error_map;
        list.push(obj);
      }
      return list;
    },
    onDetail(data) {
      this.$router.push({ name: "ErrorDetail", params: { data: data } });
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 当前行与上一行内容相同时 返回0 0 意味消除
        if (
          rowIndex > 0 &&
          row[column.key] === this.list[rowIndex - 1][column.key]
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          let rows = 1;
          // 需要合并的行数
          for (let i = rowIndex; i < this.list.length - 1; i++) {
            if (row[column.key] === this.list[i + 1][column.key]) {
              rows++;
            }
          }
          return {
            rowspan: rows,
            colspan: 1
          };
        }
      }
    },
    onBack() {
      this.$router.back(-1);
    }
  }
};
</script>

<style scoped>
.page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  background-color: #f0f2f5;
  overflow: scroll;
}
.container {
  width: 95%;
  font-size: 26px;
  display: flex;
  flex-flow: column nowrap;
  margin: 0px auto 50px auto;
}
.line {
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 20px;
}
>>> .ivu-table-cell {
  padding-left: 15px;
  padding-right: 15px;
  line-height: 1.2;
}
>>> .ivu-table th {
  background-color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/TotalSummary.vue